import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookinpune() {



  const cardData = {




keyword: "Online Cab Booking Pune",

headingDescription: "Garud Cab Service provides convenient and reliable Online Cab Booking in Pune for airport transfers, railway station pickups, corporate travel, family journeys, local sightseeing, outstation trips, and long-distance transportation. Customers can book a suitable chauffeur-driven cab online according to their pickup location, destination, travel date, vehicle requirement, and journey type. Our fleet options are suitable for individuals, couples, families, and groups, with comfortable seating and practical luggage space. With clean and well-maintained vehicles, professional drivers, flexible pickup arrangements, transparent pricing, easy booking assistance, and 24/7 customer support, Garud Cab Service makes online cab booking convenient for travel from Pune to destinations across Maharashtra and nearby states.",

topPlaces: [
  
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees for Sai Baba Darshan and other religious activities. Travelers from Pune can book a private cab online for a comfortable direct journey with flexible timings. Garud Cab Service offers suitable vehicles for families, senior citizens, and small groups, with options for one-way travel, return trips, and additional pilgrimage stops."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a popular spiritual destination in the Sahyadri hills and is home to the revered Bhimashankar Jyotirlinga Temple. Devotees and nature lovers can conveniently arrange their journey through online cab booking from Pune. A private chauffeur-driven cab provides door-to-door transportation and allows passengers to plan flexible departure and return timings."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major cultural and commercial destination in southern Maharashtra, known for temples, heritage attractions, traditional cuisine, and local markets. Customers traveling from Pune can book a cab online for direct transportation with comfortable seating and practical luggage space. Garud Cab Service provides one-way and round-trip options with professional chauffeurs and flexible travel arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, forts, sea views, and relaxing weekend trips. Online cab booking from Pune makes it convenient for couples and families to arrange private transportation in advance. Customers can choose a suitable vehicle and customize their journey to include Alibaug's beaches and nearby coastal attractions."
  },
  {
    title: "Satara",
    description: "Satara is surrounded by the Sahyadri ranges and offers attractions such as Kaas Plateau, Thoseghar Waterfalls, and historic forts. It is a convenient destination for families and nature lovers traveling from Pune. Garud Cab Service provides online cab booking for direct trips, return journeys, and customized sightseeing plans with flexible pickup locations and professional drivers."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination from Pune for beach holidays, family vacations, group trips, and extended road journeys. Travelers can book their cab online in advance and select a vehicle according to their passenger and luggage requirements. Garud Cab Service provides private chauffeur-driven transportation with one-way and round-trip options for a convenient journey."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill destination near Pune known for scenic valleys, waterfalls, lakes, forts, and pleasant weekend surroundings. Customers can book a cab online in advance for a convenient one-way trip, round journey, or customized sightseeing plan. Garud Cab Service provides private chauffeur-driven transportation for couples, families, and small groups traveling from Pune."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for viewpoints, Venna Lake, strawberry farms, waterfalls, and lush mountain landscapes. Travelers from Pune can use online cab booking to plan their journey in advance and select a suitable vehicle for their group. Customers can choose one-way, round-trip, or sightseeing transportation with flexible pickup and return arrangements."
  },
  {
    title: "Nashik",
    description: "Nashik is an important destination from Pune for pilgrimage, business travel, family visits, and tourism, with attractions including temples, riverfront areas, and vineyards. Online cab booking allows passengers to arrange private transportation before their journey. Garud Cab Service provides comfortable chauffeur-driven vehicles with convenient pickup and drop facilities for individuals, families, and groups."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major destination for heritage tourism, religious travel, business visits, and family journeys. Customers can arrange online cab booking from Pune for direct travel and customize their itinerary according to their plans. Garud Cab Service provides comfortable vehicles, experienced drivers, flexible pickup arrangements, and convenient return journey options."
  }
],



"services": [
{
"name": "Online Cab Booking Pune",
"description": "Book Online Cab Booking Pune for convenient chauffeur-driven transportation with scheduled pickup and direct destination drop. Choose Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and Tempo Traveller options for local travel, airport transfers, corporate journeys, sightseeing, family trips, and outstation travel."
},
{
"name": "Online Cab Booking Pune",
"description": "Use Online Cab Booking Pune to reserve a comfortable private vehicle according to your travel date, pickup location, passenger count, and destination. Enjoy professional chauffeur service, clean AC vehicles, convenient booking arrangements, and flexible options for city, airport, one-way, round-trip, and outstation journeys."
},
{
"name": "Online Auto Booking in Pune",
"description": "Choose Online Auto Booking in Pune for convenient local transportation with scheduled pickup and destination drop facilities. The service is suitable for short-distance city travel, daily commuting, shopping, appointments, railway station transfers, residential pickups, and other local transportation requirements."
},
{
"name": "Taxi Booking Pune",
"description": "Make Taxi Booking Pune for reliable private transportation with professional chauffeurs and comfortable vehicles. Select a suitable sedan, MUV, SUV, or premium vehicle for local rides, airport transfers, corporate travel, sightseeing, family journeys, railway station transfers, and outstation trips."
},
{
"name": "Online Taxi Booking Pune",
"description": "Book Online Taxi Booking Pune for convenient transportation with flexible pickup arrangements and direct destination drop. Choose comfortable AC vehicles according to passenger capacity and luggage requirements for local travel, airport transportation, business journeys, family trips, sightseeing, and outstation destinations."
},
{
"name": "Mumbai Airport to Pune Taxi Online Booking",
"description": "Reserve Mumbai Airport to Pune Taxi Online Booking for convenient airport pickup and direct transportation to Pune. Professional chauffeurs provide comfortable AC travel with luggage-friendly vehicles, making the service suitable for families, corporate passengers, tourists, and travelers arriving at Mumbai Airport for onward travel to Pune."
},
{
"name": "Pune to Shirdi Cab Booking Online",
"description": "Book Pune to Shirdi Cab Booking Online for a comfortable private pilgrimage journey with scheduled pickup and direct drop in Shirdi. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for Sai Baba darshan, family travel, one-way transfers, round trips, and sightseeing."
},
{
"name": "Online Car Booking in Pune",
"description": "Choose Online Car Booking in Pune for convenient chauffeur-driven transportation across the city and to outstation destinations. Select Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or Tempo Traveller vehicles according to your group size, luggage, and journey requirements."
},
{
"name": "Online Taxi Pune",
"description": "Book Online Taxi Pune for comfortable and convenient transportation with professional drivers and well-maintained AC vehicles. The service is suitable for local travel, airport transfers, office transportation, sightseeing, hotel transfers, family journeys, railway station pickups, and outstation trips."
},
{
"name": "Online Cab Services in Pimpri Chinchwad",
"description": "Choose Online Cab Services in Pimpri Chinchwad for convenient local, airport, corporate, and outstation transportation with scheduled pickup and direct destination drop. Comfortable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options are available for individuals, families, professionals, and groups."
},
{
"name": "Online Cab Services in Pimpri Chinchwad Contact Number",
"description": "Use Online Cab Services in Pimpri Chinchwad Contact Number to arrange convenient cab bookings, pickup schedules, vehicle requirements, and travel details. Customers can select suitable AC vehicles for local transportation, airport transfers, corporate travel, family journeys, sightseeing, and outstation trips."
},
{
"name": "Online Cab Service Innova Crysta",
"description": "Book Online Cab Service Innova Crysta for premium chauffeur-driven transportation with spacious seating, comfortable AC interiors, generous luggage capacity, and a refined travel experience. The Innova Crysta is suitable for airport transfers, corporate travel, family journeys, sightseeing, long-distance routes, and outstation trips."
},
{
"name": "Online Cab Services in Innova Cabs",
"description": "Choose Online Cab Services in Innova Cabs for comfortable group and family transportation with spacious seating, AC interiors, practical luggage capacity, and professional chauffeur service. Innova cabs are suitable for airport transfers, local travel, sightseeing, corporate trips, family journeys, and outstation travel."
},
{
"name": "Online Cab Service in Pune",
"description": "Book Online Cab Service in Pune for reliable private transportation with convenient online reservation, scheduled pickup, and direct destination drop. Select economical Sedan, spacious Ertiga, Innova, premium Innova Crysta, Kia Carens, or SUV options for local, airport, corporate, tourist, and outstation travel."
},
{
"name": "Ertiga Outstation Booking Pune",
"description": "Reserve Ertiga Outstation Booking Pune for comfortable family and group transportation to destinations outside Pune. The Ertiga provides spacious seating, AC interiors, practical luggage capacity, and professional chauffeur service for one-way transfers, round trips, sightseeing, pilgrimages, and long-distance journeys."
},
{
"name": "Online Cab Booking Pune",
"description": "Make Online Cab Booking Pune for flexible private transportation with convenient pickup from your home, office, hotel, airport, or other location. Choose from multiple vehicle categories according to passenger count, luggage requirements, travel distance, and preferred comfort level."
},
{
"name": "Online Taxi Booking Pune",
"description": "Choose Online Taxi Booking Pune for scheduled chauffeur-driven transportation with comfortable AC vehicles and convenient destination drop. The service is suitable for city travel, airport transfers, business meetings, family trips, sightseeing, railway station transportation, and outstation journeys."
},
{
"name": "Online Cab Service in Pune",
"description": "Book Online Cab Service in Pune for convenient local and intercity transportation with professional chauffeurs and clean AC vehicles. Flexible vehicle options are available for airport travel, corporate transportation, family journeys, tourist trips, one-way transfers, round trips, and long-distance outstation travel."
},
{
"name": "Online Cabs in Pune",
"description": "Choose Online Cabs in Pune for convenient transportation with multiple vehicle categories available for different passenger and luggage requirements. Enjoy scheduled pickup, comfortable AC travel, professional chauffeurs, and suitable options for local rides, airport transfers, corporate travel, sightseeing, and outstation journeys."
},
{
"name": "Taxi Booking in Pune",
"description": "Book Taxi Booking in Pune for private and comfortable transportation with professional chauffeur service and convenient pickup arrangements. Choose Sedan, Swift Dzire, Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or other suitable vehicles for local and outstation travel."
},
{
"name": "Pune to Mumbai Cab Booking",
"description": "Reserve Pune to Mumbai Cab Booking for a comfortable intercity journey with private chauffeur-driven transportation. Enjoy flexible pickup from Pune, direct destination drop in Mumbai, clean AC interiors, luggage space, and suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options."
},
{
"name": "Pune to Mumbai Airport Cab",
"description": "Book Pune to Mumbai Airport Cab for convenient airport transportation with scheduled pickup from Pune and direct drop at Mumbai Airport. Professional chauffeurs and comfortable AC vehicles provide a practical travel option for families, business passengers, tourists, and travelers carrying luggage."
},
{
"name": "Pune to Shirdi Cab Booking",
"description": "Choose Pune to Shirdi Cab Booking for comfortable private transportation to Shirdi with professional chauffeurs and well-maintained AC vehicles. The service is suitable for Sai Baba darshan, family pilgrimages, senior passengers, tourists, one-way journeys, round trips, and planned sightseeing."
},
{
"name": "Pune to Nashik Cab Service",
"description": "Book Pune to Nashik Cab Service for convenient outstation transportation with experienced chauffeurs and comfortable AC vehicles. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for family travel, business visits, sightseeing, religious trips, one-way transfers, and round-trip journeys."
},
{
"name": "Pune to Mahabaleshwar Cab",
"description": "Reserve Pune to Mahabaleshwar Cab for a comfortable hill-station journey with professional chauffeur service and private AC transportation. The service is suitable for family holidays, couple trips, sightseeing, weekend travel, group journeys, one-way transfers, and round-trip tour plans."
},
{
"name": "Pune to Lonavala Cab Booking",
"description": "Book Pune to Lonavala Cab Booking for convenient private transportation to Lonavala with scheduled pickup and direct destination drop. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles for weekend trips, family outings, sightseeing, couple travel, and round-trip journeys."
},
{
"name": "Pune to Goa Cab Service",
"description": "Choose Pune to Goa Cab Service for comfortable long-distance transportation with professional chauffeurs and spacious AC vehicles. Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options are suitable for family holidays, group trips, couple travel, sightseeing, one-way journeys, and round trips."
},
{
"name": "Pune to Kolhapur Cab",
"description": "Book Pune to Kolhapur Cab for reliable intercity transportation with comfortable AC vehicles and professional chauffeurs. The service is suitable for business travel, family visits, religious journeys, sightseeing, personal trips, one-way transfers, and round-trip travel between Pune and Kolhapur."
},
{
"name": "Pune to Bangalore Cab",
"description": "Reserve Pune to Bangalore Cab for long-distance private transportation with experienced chauffeurs and comfortable AC vehicles. Choose suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options for business travel, family journeys, personal visits, and planned one-way or round-trip travel."
},
{
"name": "Pune to Hyderabad Cab",
"description": "Book Pune to Hyderabad Cab for convenient long-distance transportation with professional chauffeur service and well-maintained AC vehicles. The service is suitable for business travel, family journeys, personal visits, airport connections, one-way transfers, round trips, and other intercity travel requirements."
},
{
"name": "Pune Cab Booking Online",
"description": "Choose Pune Cab Booking Online for convenient private transportation with flexible pickup locations and scheduled destination drop. Select an economical sedan, spacious MUV, premium SUV, or other suitable vehicle according to your passenger count, luggage requirements, journey type, and travel distance."
},
{
"name": "Online Taxi Booking Pune",
"description": "Make Online Taxi Booking Pune for comfortable city and outstation transportation with professional chauffeurs and convenient online reservation. Suitable vehicles are available for airport transfers, corporate travel, family trips, sightseeing, railway station transportation, one-way journeys, and round-trip travel."
},
{
"name": "Cab Service in Pune",
"description": "Book Cab Service in Pune for reliable local, airport, corporate, tourist, and outstation transportation with experienced chauffeurs and comfortable AC vehicles. Customers can select Sedan, Swift Dzire, Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and group travel options."
},
{
"name": "Taxi Service Pune",
"description": "Choose Taxi Service Pune for convenient private transportation with clean AC vehicles, professional chauffeurs, and flexible pickup and drop facilities. The service is suitable for city travel, airport transfers, office transportation, sightseeing, family journeys, railway station transfers, and outstation trips."
},
{
"name": "Book Cab Online Pune",
"description": "Book Cab Online Pune for quick and convenient chauffeur-driven transportation with scheduled pickup and direct destination drop. Select a suitable vehicle for local rides, airport transfers, corporate travel, family journeys, sightseeing, one-way trips, round trips, and long-distance outstation travel."
},
{
"name": "Online Taxi Service Pune",
"description": "Choose Online Taxi Service Pune for convenient transportation with flexible booking arrangements, professional chauffeurs, and comfortable AC vehicles. The service is suitable for local rides, airport travel, corporate requirements, family trips, sightseeing, railway station transfers, and outstation journeys."
},
{
"name": "Pune Taxi Booking",
"description": "Make Pune Taxi Booking for reliable private transportation with convenient pickup and destination drop facilities. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or other suitable vehicles for city travel, airport transfers, business trips, family journeys, sightseeing, and outstation travel."
},
{
"name": "Cab Booking Pune",
"description": "Book Cab Booking Pune for comfortable chauffeur-driven transportation with scheduled pickup and direct drop. Flexible vehicle options are available for individuals, families, corporate passengers, tourists, and groups traveling locally, to the airport, railway station, or outstation destinations."
},
{
"name": "Pune Cab Service",
"description": "Choose Pune Cab Service for convenient and comfortable private transportation throughout Pune and to nearby cities. Enjoy professional chauffeur service, clean AC vehicles, flexible pickup arrangements, and suitable options for local travel, airport transfers, corporate transportation, sightseeing, family trips, and outstation journeys."
},
{
"name": "Outstation Cab Booking Pune",
"description": "Reserve Outstation Cab Booking Pune for comfortable long-distance journeys with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or Tempo Traveller options for one-way transfers, round trips, family tours, pilgrimages, business travel, and sightseeing."
},
{
"name": "Pune Airport Cab Booking",
"description": "Book Pune Airport Cab Booking for convenient pickup and drop transportation to and from Pune Airport. Enjoy scheduled travel, professional chauffeurs, luggage-friendly AC vehicles, and multiple vehicle options suitable for individuals, families, tourists, corporate passengers, and groups."
},
{
"name": "Local Cab Booking Pune",
"description": "Choose Local Cab Booking Pune for convenient city transportation with scheduled pickup and destination drop facilities. The service is suitable for daily commuting, office travel, shopping, appointments, hotel transfers, railway station trips, airport connections, sightseeing, and family transportation."
},
{
"name": "Online Car Rental Pune",
"description": "Book Online Car Rental Pune with professional chauffeur-driven vehicles for flexible local and outstation travel. Choose Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or Tempo Traveller options according to your passenger count, luggage, travel duration, and destination."
}
],
"tableData": [
["Online Cab Booking Pune", "Online Cab Booking Pune"],
["Online Auto Booking in Pune", "Taxi Booking Pune"],
["Online Taxi Booking Pune", "Mumbai Airport to Pune Taxi Online Booking"],
["Pune to Shirdi Cab Booking Online", "Online Car Booking in Pune"],
["Online Taxi Pune", "Online Cab Services in Pimpri Chinchwad"],
["Online Cab Services in Pimpri Chinchwad Contact Number", "Online Cab Service Innova Crysta"],
["Online Cab Services in Innova Cabs", "Online Cab Service in Pune"],
["Ertiga Outstation Booking Pune", "Online Cab Booking Pune"],
["Online Taxi Booking Pune", "Online Cab Service in Pune"],
["Online Cabs in Pune", "Taxi Booking in Pune"],
["Pune to Mumbai Cab Booking", "Pune to Mumbai Airport Cab"],
["Pune to Shirdi Cab Booking", "Pune to Nashik Cab Service"],
["Pune to Mahabaleshwar Cab", "Pune to Lonavala Cab Booking"],
["Pune to Goa Cab Service", "Pune to Kolhapur Cab"],
["Pune to Bangalore Cab", "Pune to Hyderabad Cab"],
["Pune Cab Booking Online", "Online Taxi Booking Pune"],
["Cab Service in Pune", "Taxi Service Pune"],
["Book Cab Online Pune", "Online Taxi Service Pune"],
["Pune Taxi Booking", "Cab Booking Pune"],
["Pune Cab Service", "Outstation Cab Booking Pune"],
["Pune Airport Cab Booking", "Local Cab Booking Pune"],
["Online Car Rental Pune", ""]
],



whychoose: [
  {
    WhyChooseheading: "Online Cab Booking in Pune with Easy Reservation",
    WhyChoosedescription: "Garud Cab Service makes online cab booking in Pune convenient for local travel, airport transfers, railway station pickups, corporate transportation, family trips, sightseeing, and outstation journeys."
  },
  {
    WhyChooseheading: "Plan Your Ride Before Departure",
    WhyChoosedescription: "Reserve your cab in advance by providing your pickup location, destination, travel date, passenger count, preferred vehicle, and required pickup time for better travel planning."
  },
  {
    WhyChooseheading: "Airport Cab Booking Online",
    WhyChoosedescription: "Arrange Pune Airport pickup or drop online according to your flight schedule, whether you are travelling from your home, hotel, office, railway station, or another location in Pune."
  },
  {
    WhyChooseheading: "Local Pune Cabs for Everyday Travel",
    WhyChoosedescription: "Online booking is useful for city rides such as shopping, office travel, hotel transfers, appointments, family visits, railway station transportation, and local sightseeing."
  },
  {
    WhyChooseheading: "Outstation Cab Reservations from Pune",
    WhyChoosedescription: "Plan your intercity journey online for suitable destinations from Pune, with cab arrangements based on your route, travel dates, passenger requirements, and preferred trip type."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Booking Choices",
    WhyChoosedescription: "Select a one-way cab when you only need a direct drop or arrange a round-trip vehicle when your itinerary includes returning to Pune after your visit."
  },
  {
    WhyChooseheading: "Options for Families & Business Travellers",
    WhyChoosedescription: "Families, couples, individual passengers, and corporate travellers can request a vehicle according to group size, luggage, comfort requirements, and purpose of travel."
  },
  {
    WhyChooseheading: "Booking Assistance from Garud Cab Service",
    WhyChoosedescription: "Send your complete travel details to Garud Cab Service to discuss vehicle availability, pickup timing, destination, trip requirements, and confirmation for your online cab reservation."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Online Cab Booking in Pune?",
    answer: "Yes, Garud Cab Service provides online cab booking in Pune for local transportation, airport transfers, railway station travel, corporate trips, family journeys, sightseeing, and outstation travel."
  },
  {
    question: "How can I book a cab online in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred vehicle, and trip type with Garud Cab Service to arrange your online cab booking."
  },
  {
    question: "Can I book a Pune Airport cab online?",
    answer: "Yes, Pune Airport pickup and drop cabs can be requested online according to your flight timing and preferred pickup or drop location."
  },
  {
    question: "Can I book an outstation cab online from Pune?",
    answer: "Yes, online cab arrangements can be made for suitable outstation destinations based on the route, travel date, passenger details, and vehicle availability."
  },
  {
    question: "Can I book a one-way cab online?",
    answer: "Yes, one-way cab service can be arranged online when you require direct transportation from Pune to your selected destination."
  },
  {
    question: "Is online round-trip cab booking available?",
    answer: "Yes, round-trip cab bookings can be arranged for holidays, sightseeing trips, family visits, religious journeys, business travel, and other return journeys."
  },
  {
    question: "Can I book a cab online for railway station pickup?",
    answer: "Yes, Pune Railway Station pickup and drop arrangements can be requested online by sharing your train timing and required pickup or destination details."
  },
  {
    question: "Can companies book cabs online for employees?",
    answer: "Yes, corporate travellers and companies can use online cab booking for employee transportation, client transfers, airport travel, meetings, and business requirements."
  },
  {
    question: "Can I book a cab online for early-morning travel?",
    answer: "Yes, advance online booking can be requested for early-morning airport transfers, railway station drops, and other scheduled journeys based on vehicle availability."
  },
  {
    question: "How early should I make an online cab booking?",
    answer: "Advance booking is recommended for airport transfers, weekends, holidays, and planned outstation trips so the required vehicle and travel schedule can be arranged in advance."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Kadam",
    feedback: "I booked my Pune airport cab online before an early flight. Providing the travel details in advance made the airport transfer much easier to organize.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Desai",
    feedback: "We used online cab booking for our family outstation trip from Pune. It was convenient to arrange the vehicle and travel details before our journey.",
    rating: 5
  }
];

  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Pune",
  "image": "https://garudcabs.com/assets/images/online-cab-booking-pune.webp",
  "description": "Book an Online Cab in Pune with Garud Cab for quick, convenient, and reliable local, airport, and outstation travel. Get online taxi booking services in Pune for city rides, Mumbai Airport to Pune transfers, one way trips, round trips, and intercity journeys with Sedan, Ertiga, SUV, Innova, and Innova Crysta cab options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/online-cab-booking-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Online Cab Booking Pune | Taxi Booking & Airport Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book a cab online in Pune with Garud Cab for local, airport, and outstation travel. Get convenient online taxi booking for Pune city rides, Mumbai Airport to Pune transfers, one way, round trip, and intercity cab services."
  />

  <meta
    name="keywords"
    content="Online Cab Booking Pune, online cab booking Pune, online auto booking in Pune, taxi booking Pune, online taxi booking Pune, Mumbai Airport to Pune cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookinpune;